var waitFor = require('../utils/waitFor');

waitFor('body.advanced-search-results', function() {

  var dt = require( 'datatables.net' )( window, jQuery ),
    dt_fixedheader = require( 'datatables.net-fixedheader' )( window, jQuery ),
    dtUtils = require('../utils/dtUtils'),
		layoutImagesGrid = require('./layout-images-grid');

	var $advSearchForm = $('#advanced-search-criteria'),
		resultsTableDt;

  $('#edit-advanced-search').on('click', function(e){
    e.preventDefault();

    $advSearchForm.toggleClass('is-collapsed');
  });

  $('.pill__x').on('click', function(e){
  	e.stopImmediatePropagation();

  	var $pill = $(e.currentTarget).parent(),
  		field = $pill.data('field'),
  		$theField = $advSearchForm.find('[name="adv-search-' + field + '"]');

  	if($theField.hasClass('comp-select'))
  		$theField.val('any');
  	else if($theField.attr('type') == 'text')
  		$theField.val('');
  	else
  		$theField.prop('checked', false);

  	$pill.hide();
  	$advSearchForm.submit();

  });

  $('.your-selections__pill').on('click', function(e){

  	var field = $(e.currentTarget).data('field'),
  		$theField = $advSearchForm.find('[name="adv-search-' + field + '"]'),
  		isSelecter = $theField.parent().hasClass('selecter');

    $advSearchForm.removeClass('is-collapsed');

    setTimeout(function(){
    	if(isSelecter)
    		$theField.next('.selecter-selected').click();
    	else
	    	$theField.focus();
    }, 250);

  });

  function _getSeriesURL(data){
    return window.SITE_SETTINGS.blogurl + '/series/' + data.series_name;
  }

  // Results table
  var colData = [
    {
      title: 'Face View',
      func: function(data){
        return '<img src="' + SITE_SETTINGS.advSearchImageDir + '/' + data.image + '" alt="" />';
      },
      width: '150px',
      noSort: true
    },
    {
      title: 'Series',
      func: function(data){
        return '<a href="' + _getSeriesURL(data) + '">' + data.series_name + '</a>';
      },
      width: '90px',
      className: 'col-emphasize'
    },
    {
      title: 'Layout',
      prop: 'layout_name',
      width: '90px',
      className: 'col-emphasize'
    },
    {
      title: 'Build',
      func: function(data){
        return '<a href="' + _getSeriesURL(data) + '/?part-number=' + data.series_name + data.layout_name + '" class="build"><span class="visually-hidden">Build</span></a>';
      },
      width: '80px',
      className: 'col-emphasize',
      noSort: true
    },
    {
      title: 'Performance Level',
      prop: 'performance',
      format: 'joinBreak',
      width: '110px',
      noSort: true
    },
    {
      title: 'Width of Male (mm)',
      prop: 'width',
      format: 'toFixed',
      width: '110px'
    },
    {
      title: 'Height of Male (mm)',
      prop: 'height',
      format: 'toFixed',
      width: '110px'
    },
    {
      title: 'Mounting',
      prop: 'mounting',
      format: 'joinBreak',
      width: '110px',
      noSort: true
    },
    {
      title: 'Termination',
      prop: 'termination',
      format: 'joinBreak',
      width: '110px',
      noSort: true
    },
    {
      title: 'Temp. Range',
      func: function(data){
        return data.low_temp + '&deg; to ' + data.high_temp + '&deg;';
      },
      width: '110px',
      noSort: true
    },
    {
      title: 'Waterproof',
      prop: 'waterproof',
      format: 'joinBreak',
      width: '110px',
      noSort: true
    },
  ];

  // process results for columns
  function drawTable(){
	  resultsTableDt = $('#adv-search-results-table').DataTable({
	    data: dtUtils.formatResultsData(window.advSearchResults, colData),
	    columns: dtUtils.buildDataTablesColumns(colData),
	    fixedHeader: true,
	    searching: false,
	    lengthChange: false,
	    info: false,
	    order: [[ 1, 'asc' ]], // order by series
	    dom: '<"dataTables-top-pagination"p>t<"dataTables-bottom-pagination"p>'
	  });
	}
	drawTable();


  $('#adv-search-results-table').on('page.dt', function(){
    $('html, body').animate({
        scrollTop: $(".search-results__meta").offset().top - 40
    }, 300);
  });


  // image results
  var gridViewInitted = false;
  var $loading = $('#face-loading'),
    seriesRelationshipData = false;

  function gridViewInit(){
  	if(gridViewInitted)
      return;

    $loading.show();

    // fetch seriesRelationshipData
    $.post(window.SITE_SETTINGS.ajaxurl, {
      action: 'posi_get_series_relationships'
    }, function (data) {

      seriesRelationshipData = data;
      _gridViewInitWithData();

    }, 'json');

  }
  function _gridViewInitWithData() {
    var categorizationData = {},
      seriesCategory = {};

    $.each(seriesRelationshipData, function (categoryName, seriesList) {
      $.each(seriesList, function (i, seriesName) {
        seriesCategory[seriesName] = categoryName;
      });
    });

    // create categorization data base on each layout's series category
    $.each(window.advSearchResults, function (i, layout) {
      var catName = seriesCategory[layout.series_name];

      categorizationData[layout.image] = catName;
    });


    gridViewInitted = true;
    $loading.hide();
    layoutImagesGrid.init(window.advSearchResults, categorizationData);
  }
  $('a[href="#grid"]').on('click', function(){
  	resultsTableDt.destroy();
  	gridViewInit();
  });
  $('a[href="#list"]').on('click', drawTable);


});
